import { Service } from '@angular/core';
import { BehaviorSubject, type Observable } from 'rxjs';

import { type NavigationLink } from '../models/navigation-link';

/** Provides logic related to navigation. */
@Service()
export class NavigationService {
	/** Sidebar navigation links. */
	public readonly sidebarNavigationLinks$: Observable<readonly NavigationLink[]>;

	private readonly _sidebarNavigationLinks$: BehaviorSubject<readonly NavigationLink[]>;

	public constructor() {
		this._sidebarNavigationLinks$ = new BehaviorSubject<readonly NavigationLink[]>([]);
		this.sidebarNavigationLinks$ = this._sidebarNavigationLinks$.asObservable();
	}

	/**
	 * Sets sidebar navigation links.
	 * @param links List of navigation links to set.
	 */
	public setSidebarNavigationLinks(links: NavigationLink[]): void {
		this._sidebarNavigationLinks$.next(links);
	}
}
